import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import styles from './index.module.scss'

function ConformationModal({ showModal, hidemodal, title, onSubmit }) {


    return (
        <Modal
            closeButton
            show={showModal}
            onHide={hidemodal}
            className={styles.information_modal_align}
            backdrop="static"

        >
            <Modal.Body>
                <div className={styles.modalContent}>

                    {/* <div className={styles.closeBar} onClick={hidemodal}>
                <SimpleCloseIcon />
            </div> */}
                    <div className={styles.title}>{title}</div>





                </div>
            </Modal.Body>

            <div className={styles.btn_container}>
                <Button
                    className={styles.patient_consent_reject_button}
                    onClick={hidemodal}
                >
                    NO
                </Button>

                <Button
                    className={styles.patient_consent_accept_button}
                    onClick={onSubmit}
                >
                    YES
                </Button>
            </div>

        </Modal>
    )
}

export default ConformationModal